/**
 * @module components/LegendSetting
 * @description 图例设置分类组件（Phase 5 迁移模板）
 *
 * 【迁移模板说明】
 * 本组件是 Phase 5 的第一个迁移模板，所有后续组件遵循相同模式：
 *
 * 状态管理模式：
 *   读: useChartSettingsSelector(s => s.base.xxx ?? s.draft.xxx)
 *   写: dispatch({ type: CSActionType.UPDATE_DRAFT, payload: { xxx: value } })
 *
 * 显隐模式：
 *   不判断 chartType / QB 条件 → 由 Panel 层 Config A 的 visible 控制
 *   子项显隐 → 由 props.visibleItems 控制
 *
 * 移除项：
 *   ❌ DVA useSelector / useDispatch
 *   ❌ handleChangeFormValue 回调
 *   ❌ initLegendSettingEffect 等 DVA effect
 *   ❌ chartType 显隐判断（改由 Panel visibleItems 传入）
 *
 * @see 执行计划 Phase 5 — 已有组件迁移
 */

import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import LegendPosition from './LegendPosition';
import SeriesSortBy from './SeriesSortBy';
import './index.scss';

interface LegendSettingProps {
  /** 子项显隐表 — 由 Panel 层根据 Config A + QB 计算后传入 */
  visibleItems?: Record<string, boolean>;
}

/**
 * LegendSetting — 图例设置分类组件
 *
 * 内含 LegendPosition（图例位置）+ SeriesSortBy（系列排序）
 * 折叠行为自理（ConfigCollapseCard）
 */
const LegendSetting: React.FC<LegendSettingProps> = ({ visibleItems }) => {
  const { formatMessage } = useIntl();

  return (
    <ConfigCollapseCard
      title={formatMessage({ id: 'dbl_chart_legend_setting' })}
      className="dbl-legend-setting"
      defaultActiveIds={[]}
    >
      {/* 图例位置 — 始终显示 */}
      <LegendPosition />

      {/* 系列排序 — 仅多维度时显示（由 Panel 通过 visibleItems 控制） */}
      {visibleItems?.SeriesSortBy && <SeriesSortBy />}
    </ConfigCollapseCard>
  );
};

export default React.memo(LegendSetting);
